var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowThickUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99997 2.14988C4.82075 2.14988 4.64155 2.21831 4.50492 2.35488L0.205141 6.6547C-0.0683805 6.92822 -0.0683805 7.37169 0.205141 7.6451C0.478553 7.91851 0.921933 7.91851 1.19548 7.6451L4.99997 3.84038L8.80449 7.64497C9.07801 7.91838 9.52135 7.91838 9.79474 7.64497C10.0684 7.37156 10.0684 6.92809 9.79474 6.65457L5.49503 2.35475C5.35832 2.21815 5.17913 2.14988 4.99997 2.14988Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThickUp);
export default __webpack_public_path__ + "static/media/arrow-thick-up.b5453d7ea640d5b3f8fcf9d0c0cfa1b0.svg";
export { ForwardRef as ReactComponent };